/* eslint-disable @typescript-eslint/no-empty-interface */
import {mq, viewportsArray, mediaQueries, multipliers, breakpoints} from './foundation/breakpoints'

import colors from './foundation/colors'
import fonts from './foundation/fonts'
import animation from './foundation/animation'
import buttons from './foundation/buttons'

import typography from './foundation/typography'

import layout from './foundation/layout'

import focus from './foundation/focus'

import {spaces} from './foundation/spaces'

import {normalizeStyles, expandVariants} from './utils'

import type * as CSS from 'csstype'

export const theme = {
  mq,
  spaces,
  viewportsArray,
  colors,
  mediaQueries,
  multipliers,
  breakpoints,
  fonts,
  buttons,
  typography,
  animation,
  layout,
  focus,
  normalizeStyles,
  expandVariants,
  disableScaling: false,
}

export type ResponsiveValue<T> = T | null | undefined | Array<T | null | undefined>

type CSSProperties = CSS.PropertiesFallback<string | number | null, string | number | null>

type CSSPseudos = {
  [P in CSS.Pseudos]?: StyleProps
}

export interface StyleProps extends CSSProperties, CSSPseudos {
  [key: string]: StyleProps | ResponsiveValue<string | number | null | undefined>
}

export type Theme = typeof theme

// Breakpoint utils
export {mq, viewportsArray} from './foundation/breakpoints'
